import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IOpenModalReducer {
  openModal: string;
}
interface IOpenModalGetter {
  header: IOpenModalReducer
}

export const headerModalSlice = createSlice({
  name: 'header',
  initialState: {
    openModal: ''
  },
  reducers: {
    /**
     * Sets the open modal, or if the modal is the same as an already
     * open modal, then the modal is closed.
     *
     * If the screen is less than 1024 pixels (the current defined
     * required for CMS), then we automatically open the 'mobile'
     * version of the menu
     *
     * This works for the header because we have a mobile variety of
     * every modal in the global header
     * @param state
     * @param action
     */
    setOpenModal: (state: IOpenModalReducer, action: PayloadAction<string>) => {
      const alreadyOpened = action.payload === state.openModal || 'mobile' + action.payload === state.openModal
      const isMobile = window.innerWidth < 1024 && action.payload !== ''

      if (alreadyOpened) {
        state.openModal = ''
      } else if (isMobile && !action.payload.startsWith('mobile')) {
        state.openModal = 'mobile' + action.payload
      } else {
        state.openModal = action.payload
      }
    }
  }
})

export const {
  setOpenModal
} = headerModalSlice.actions

// GETTERS
export const getOpenModal = (state: IOpenModalGetter) => state.header.openModal

export default headerModalSlice.reducer
